import { thor } from "../../typings/thor";

export class MapController {
    public static $inject: string[] = [
        "$log",
        "mapService",
        "uiGmapGoogleMapApi",
        "utilsService"
    ];

    public coords; // Binded
    public isDraggable; // Binded
    public map;
    public marker;
    public onDragEnd; // Binded
    public utilsService;

    private $log: ng.ILogService;
    private mapService;
    private uiGmapGoogleMapApi;

    constructor(
        $log,
        mapService,
        uiGmapGoogleMapApi,
        utilsService
    ) {
        this.$log = $log;
        this.mapService = mapService;
        this.uiGmapGoogleMapApi = uiGmapGoogleMapApi;
        this.utilsService = utilsService;
    }

    public $onInit() {
        this.map = {
            center: {
                latitude: this.coords.lat,
                longitude: this.coords.lon
            },
            zoom: 14,
            options: {
                clickableIcons: false,
                disableDefaultUI: true,
                keyboardShortcuts: false,
                zoomControl: true,
                streetViewControl: true,
                disableDoubleClickZoom: true,
                scrollwheel: false,
                draggable: false
            },
            control: {}
        };

        this.marker = {
            isMarkerSet: false,
            idKey: "marker",
            coords: {
                latitude: this.coords.lat,
                longitude: this.coords.lon
            },
            options: {
                draggable: false
            },
            events: {
                dragend: this._onMarkerDragEnd.bind(this)
            }
        };

        if (this.isDraggable) {
            this.marker.options.draggable = true;
            this.map.options.draggable = true;
        }

        this.uiGmapGoogleMapApi.then(gmaps => {
            this.marker.options.animation = gmaps.Animation.DROP;
        });
    }

    public $onChanges(changesObj) {
        if (changesObj.coords && !changesObj.coords.isFirstChange()) {
            this.map.center.latitude = this.coords.lat;
            this.map.center.longitude = this.coords.lon;
            this.marker.coords.latitude = this.coords.lat;
            this.marker.coords.longitude = this.coords.lon;
        }
    }

    private _onMarkerDragEnd(marker) {
        const markerPosition = {
            lat: marker.position.lat(),
            lon: marker.position.lng()
        };

        this.mapService.geocodePosition(markerPosition)
            .then((address: thor.SaleAddress) => {
                // Use marker position instead of the geocoded address location
                // To keep the marker precision
                address.location = markerPosition;
                this.onDragEnd({
                    geocode: {
                        markerPosition: markerPosition,
                        address: address,
                        status: true
                    }
                });
            })
            .catch(status => {
                this.onDragEnd({
                    geocode: {
                        status: false
                    }
                });

                this.$log.error("Error on reverse geocoding coords", status);
            });
    }
}
